// Brand content under the team and the brand (A3). `brands/new` and `brands/$brandId` are
// siblings: a static segment wins over a param, and `new` is not a UUID.
import { createRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ProductOrder } from "../../api/generated/zod";
import { brandRoute, isUuid, teamRoute } from "../../platform/routes";
import { EditBrandScreen, NewBrandScreen } from "./BrandFormScreens";
import { BrandListScreen } from "./BrandListScreen";
import { BrandScreen } from "./BrandScreen";
import { NewProductScreen, ProductListScreen, ProductScreen } from "./ProductScreens";

// `?search=`: the brand and product lists' name filter, so a filtered view survives a reload.
const brandListSearch = z.object({ search: z.string().optional().catch(undefined) });
// The products' also keep live's creators (`by`) and order, as the library's do (spec A3d).
const productListSearch = brandListSearch.extend({
  by: z.array(z.uuid()).optional().catch(undefined),
  order: ProductOrder.optional().catch(undefined),
});

export const brandListRoute = createRoute({
  getParentRoute: () => teamRoute,
  path: "brands",
  validateSearch: (search) => brandListSearch.parse(search),
  component: BrandListScreen,
});

export const newBrandRoute = createRoute({
  getParentRoute: () => teamRoute,
  path: "brands/new",
  component: NewBrandScreen,
});

export const brandHomeRoute = createRoute({
  getParentRoute: () => brandRoute,
  path: "/",
  component: BrandScreen,
});

export const editBrandRoute = createRoute({
  getParentRoute: () => brandRoute,
  path: "edit",
  component: EditBrandScreen,
});

export const productListRoute = createRoute({
  getParentRoute: () => brandRoute,
  path: "products",
  validateSearch: (search) => productListSearch.parse(search),
  component: ProductListScreen,
});

export const newProductRoute = createRoute({
  getParentRoute: () => brandRoute,
  path: "products/new",
  component: NewProductScreen,
});

export const productRoute = createRoute({
  getParentRoute: () => brandRoute,
  path: "products/$productId",
  params: { parse: ({ productId }) => (isUuid(productId) ? { productId } : false) },
  component: ProductScreen,
});

